exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#regenerate[data-v-28d430fc] {\n    width: 194px;\n}\n", ""]);

// exports
